<template>
  <v-container fluid>
    <div>
      <v-toolbar>
        <v-spacer></v-spacer>
        <v-toolbar-title><h4>{{ vintage }} - VINTAGE LAB TESTS</h4></v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-data-table
        :headers='headers'
        :items='items'
        item-key='id'
        hide-actions
        class="elevation-1"
        >
        <template slot="items" slot-scope="props">
          <tr>
            <td>{{ props.item.number }}</td>
            <td>{{ props.item.description }}</td>
            <td v-if="tests[props.item.number]['pH']">{{ tests[props.item.number]['pH'].value }}</td>
            <td v-else></td>
            <td v-if="tests[props.item.number]['TA']">{{ tests[props.item.number]['TA'].value }}</td>
            <td v-else></td>
            <td v-if="tests[props.item.number]['VA']">{{ tests[props.item.number]['VA'].value }}</td>
            <td v-else></td>
            <td v-if="tests[props.item.number]['FSO2']">{{ tests[props.item.number]['FSO2'].value }}</td>
            <td v-else></td>
            <td v-if="tests[props.item.number]['TSO2']">{{ tests[props.item.number]['TSO2'].value }}</td>
            <td v-else></td>
            <td v-if="tests[props.item.number]['TART']">{{ tests[props.item.number]['TART'].value }}</td>
            <td v-else></td>
            <td v-if="tests[props.item.number]['L-MALIC']">{{ tests[props.item.number]['L-MALIC'].value }}</td>
            <td v-else></td>
            <td v-if="tests[props.item.number]['POT']">{{ tests[props.item.number]['POT'].value }}</td>
            <td v-else></td>
            <td v-if="tests[props.item.number]['AMM']">{{ tests[props.item.number]['AMM'].value }}</td>
            <td v-else></td>
            <td v-if="tests[props.item.number]['AM_N']">{{ tests[props.item.number]['AM_N'].value }}</td>
            <td v-else></td>
            <td v-if="tests[props.item.number]['YAN']">{{ tests[props.item.number]['YAN'].value }}</td>
            <td v-else></td>
            <td v-if="tests[props.item.number]['Brix']">{{ tests[props.item.number]['Brix'].value }}</td>
            <td v-else></td>
            <td v-if="tests[props.item.number]['GLU']">{{ tests[props.item.number]['GLU'].value }}</td>
            <td v-else></td>
            <td v-if="tests[props.item.number]['FRU']">{{ tests[props.item.number]['FRU'].value }}</td>
            <td v-else></td>
            <td v-if="tests[props.item.number]['GLUFRU']">{{ tests[props.item.number]['GLUFRU'].value }}</td>
            <td v-else></td>
            <td v-if="tests[props.item.number]['ALCOHOL']">{{ tests[props.item.number]['ALCOHOL'].value }}</td>
            <td v-else></td>
          </tr>
        </template>
      </v-data-table>
    </div>
  </v-container>
</template>

<script>
import axios from 'axios'
import async from 'async'
import numeral from 'numeral'
import Loading from './Loading'
import DeleteConfirmation from './DeleteConfirmation'
// import { debug, debuglog } from 'util'
export default {
  data () {
    return {
      headers: [
        { text: 'Lot', value: 'number', sortable: false },
        { text: 'Description', value: 'description', sortable: false },
        { text: 'pH', value: 'description', sortable: false },
        { text: 'TA', value: 'description', sortable: false },
        { text: 'VA', value: 'description', sortable: false },
        { text: 'FSO2', value: 'description', sortable: false },
        { text: 'TSO2', value: 'description', sortable: false },
        { text: 'TART', value: 'description', sortable: false },
        { text: 'MALIC', value: 'description', sortable: false },
        { text: 'POT', value: 'description', sortable: false },
        { text: 'AMM', value: 'description', sortable: false },
        { text: 'AM_N', value: 'description', sortable: false },
        { text: 'YAN', value: 'description', sortable: false },
        { text: 'BRIX', value: 'description', sortable: false },
        { text: 'GLU', value: 'description', sortable: false },
        { text: 'FRU', value: 'description', sortable: false },
        { text: 'GLU/FRU', value: 'description', sortable: false },
        { text: 'ALC', value: 'description', sortable: false }
      ],
      items: [],
      tests: {},
      allLots: []
    }
  },
  created () {
    this.retrieveAllLabs()
  },
  computed: {
    lots () {
      return this.$store.state.lotsForVintage
    },
    vintage () {
      return this.$store.state.vintage
    },
    clientcode () {
      return this.$store.state.client.CODE
    },
    lotsUpdated () {
      return this.$store.state.lotsUpdated
    },
    client () {
      return this.$store.state.client
    }
  },
  watch: {
    vintage (nv, ov) {
      this.retrieveAllLabs()
    },
    client (nv, ov) {
      this.retrieveAllLabs()
    }
  },
  methods: {
    retrieveAllLabs () {
      let url = process.env.VUE_APP_BACKEND+'labTests?allLots=true&clientcode='+this.$store.state.client.clientid+'&year='+this.vintage
      axios
        .get(url)
        .then(response => {
          this.items = response.data.data.lots
          this.tests = response.data.data.tests
        })
    },
    rowClicked (item) {
      this.$router.push({
        path: '/workorders/' + item.lotNumber
      })
    }
  }
}
</script>
<style>
</style>
